import { useState } from "react";
import { Link as RouterLink } from "react-router-dom";
import {
  Box,
  Grid,
  Paper,
  Typography,
  Link,
  Chip,
  Avatar,
  Divider,
  Stack,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  useTheme,
} from "@mui/material";
import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import ArticleIcon from "@mui/icons-material/Article";
import PersonOutlineIcon from "@mui/icons-material/PersonOutline";
import Logo from "../assets/ZakazujMeLogo4.png";
import Teamwork from "../assets/blog1.png";
import Calendar from "../assets/blog3.png";
import Inovation from "../assets/blog2.png";
import QrAppStore from "../assets/qr-appstore.png";
import QrGooglePlay from "../assets/qr-googleplay.png";
//import MobileAppPromo from "./MobileApp";

const posts = [
  {
    id: 2,
    title: "Neprisutnosti nisu retkost — ali se mogu kontrolisati",
    image: Teamwork,
    excerpt:
      "Veliki sistemi beleže visoke stope nepojavljivanja, naročito kad je čekanje duže. Dobra organizacija to ublažava.",
    author: "Zakazuj tim",
    date: "2026-01-31",
    badge: "Uvidi",
    content: [
      "U jednoj velikoj ambulantnoj praksi zabeležena je ukupna stopa nepojavljivanja od 18.3% tokom više godina. Faktori poput dužeg vremena čekanja povećavaju rizik da se korisnici ne pojave.",
      "Zato Zakazuj pomaže da raspored bude precizan: jasni termini, automatizovani podsetnici i laka izmena rezervacije smanjuju rizik da termin ostane prazan.",
      "Kada klijent vidi jasne opcije za promenu termina, veća je verovatnoća da će ga pomeriti umesto da se ne pojavi. To je win‑win: klijent zadržava termin, a biznis nema prazninu.",
      "U Zakazuj‑u se to rešava kroz precizne slotove, dostupnost po zaposlenom i ažurne informacije o radnom vremenu, pa se greške svode na minimum.",
    ],
    facts: ["Studija u ambulantnoj praksi: ukupna nepojavljivanja 18.3%."],
    sources: ["PubMed – otolaryngology practice nonattendance (2019–2021)."],
  },
  {
    id: 3,
    title: "Način podsetnika je važan",
    image: Inovation,
    excerpt:
      "Nije svaki podsetnik isti. Istraživanja pokazuju razliku između automatizovanih i personalizovanih podsetnika.",
    author: "Zakazuj tim",
    date: "2026-01-31",
    badge: "Operativa",
    content: [
      "U jednoj kontrolisanoj studiji, no-show stopa bila je 23.1% bez podsetnika, 17.3% uz automatizovane podsetnike i 13.6% uz podsetnik koji šalje osoblje.",
      "Zakazuj zato kombinuje automatizaciju sa mogućnošću personalizovanog kontakta kad je to potrebno — posebno kod novih klijenata ili skupljih usluga.",
      "Automatski podsetnik je brz i skalabilan, ali personalizovana poruka često gradi jaču vezu i poverenje. Zato sistem omogućava oba pristupa, u zavisnosti od tipa usluge.",
      "Ako je termin kompleksan ili traje duže, personalizovana potvrda može biti presudan faktor da klijent zaista dođe.",
    ],
    facts: [
      "Kontrolisana studija: 23.1% bez podsetnika, 17.3% automatizovani, 13.6% osoblje.",
    ],
    sources: ["PubMed – outpatient reminder systems (2010)."],
  },
  {
    id: 4,
    title: "Teletermini dodatno smanjuju no-show",
    image: Calendar,
    excerpt:
      "U nekim granama zdravstva teletermini imaju niže stope nepojavljivanja. Digitalna dostupnost pomaže.",
    author: "Zakazuj tim",
    date: "2026-01-31",
    badge: "Trend",
    content: [
      "U jednoj velikoj kliničkoj studiji uvođenje telemedicine bilo je praćeno padom no-show stope (npr. sa ~25.9% na ~15.1% za nove termine).",
      "Zakazuj podržava fleksibilnost: klijenti mogu da potvrde, promene ili otkažu termin brzo, što smanjuje zagušenje i rupe u rasporedu.",
      "Iako nisu svi termini pogodni za online, fleksibilnost u komunikaciji i potvrdi termina igra veliku ulogu u smanjenju nepojavljivanja.",
      "Zato je važno da se klijentima omogući brz pristup terminima preko linka ili QR koda — i da na par klikova reše sve oko rezervacije.",
    ],
    facts: [
      "Studija: no-show za nove termine pao sa 25.9% na 15.1% uz telemedicinu.",
    ],
    sources: [
      "ACG journal abstract – no-show rates pre/post telemedicine (2019 vs 2021).",
    ],
  },
];

export default function Home() {
  const theme = useTheme();
  const [activePost, setActivePost] = useState(null);

  return (
    <Grid container sx={{ minHeight: "100vh", overflowX: "hidden" }}>
      <Grid
        item
        xs={12}
        sx={{
          position: "relative",
          background:
            theme.palette.mode === "dark"
              ? "radial-gradient(1200px 800px at 20% 30%, #1e2a78 0%, #0b0f2b 50%, #0a0d20 100%)"
              : "radial-gradient(1200px 800px at 20% 30%, #1e2a78 0%, #0b0f2b 50%, #0a0d20 100%)",
          minHeight: "42vh",
        }}
      >
        <Box
          sx={{
            position: "absolute",
            inset: 0,
            background:
              "radial-gradient(600px 380px at 45% 40%, rgba(26,86,219,0.65), transparent 60%), radial-gradient(620px 420px at 65% 60%, rgba(168,85,247,0.55), transparent 62%), radial-gradient(580px 360px at 75% 30%, rgba(6,182,212,0.5), transparent 62%)",
            filter: "blur(18px)",
            opacity: 0.9,
            pointerEvents: "none",
          }}
        />

        <Box
          sx={{
            position: { xs: "static", md: "fixed" },
            top: { md: 18 },
            right: { md: 24 },
            display: "flex",
            flexWrap: "wrap",
            justifyContent: { xs: "center", md: "flex-end" },
            gap: { xs: 1, sm: 1.5, md: 2 },
            px: { xs: 2, sm: 3, md: 0 },
            py: { xs: 1, md: 0 },
            mt: { xs: 2, md: 0 },
            borderRadius: { xs: 2, md: 0 },
            background: {
              xs: "rgba(10, 13, 32, 0.6)",
              md: "transparent",
            },
            color: "rgba(255,255,255,0.95)",
            zIndex: 1100,
          }}
        >
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/home"
            sx={{
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 0.8, md: 1 },
              borderRadius: 2,
              fontWeight: 700,
              fontSize: { xs: 14, sm: 16, md: 25 },
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            Početna
          </Link>
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/cooperation"
            sx={{
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 0.8, md: 1 },
              borderRadius: 2,
              fontWeight: 700,
              fontSize: { xs: 14, sm: 16, md: 25 },
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            Saradnja
          </Link>
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/about"
            sx={{
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 0.8, md: 1 },
              borderRadius: 2,
              fontWeight: 700,
              fontSize: { xs: 14, sm: 16, md: 25 },
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            O nama
          </Link>
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/privacy-policy"
            sx={{
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 0.8, md: 1 },
              borderRadius: 2,
              fontWeight: 700,
              fontSize: { xs: 14, sm: 16, md: 25 },
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            Politika privatnosti
          </Link>
          <Link
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/login"
            sx={{
              px: 2,
              py: 1,
              borderRadius: 2,
              fontWeight: 700,
              fontSize: 25,
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "rgba(59,130,246,0.15)",
                color: "#3B82F6",
              },
            }}
          >
            Prijavi se
          </Link>
          <Link
            hidden
            underline="none"
            color="inherit"
            component={RouterLink}
            to="/userregistration"
            sx={{
              px: { xs: 1.5, sm: 2 },
              py: { xs: 0.5, sm: 0.8, md: 1 },
              borderRadius: 2,
              fontWeight: 700,
              fontSize: { xs: 14, sm: 16, md: 25 },
              background: "linear-gradient(90deg, #3B82F6 0%, #06B6D4 100%)",
              color: "white",
              boxShadow: "0 2px 8px rgba(59,130,246,0.25)",
              transition: "background 0.2s, color 0.2s",
              "&:hover": {
                background: "linear-gradient(90deg, #1D4ED8 0%, #06B6D4 100%)",
                color: "#fff",
              },
            }}
          >
            Registruj se
          </Link>
        </Box>

        <Box
          sx={{
            position: "relative",
            maxWidth: 1200,
            mx: "auto",
            pt: { xs: 12, sm: 14, md: 16 },
            pb: { xs: 6, sm: 8 },
            px: { xs: 3, sm: 5 },
            color: "white",
          }}
        >
          <Box
            component="img"
            src={Logo}
            alt="Zakazuj"
            sx={{
              height: { xs: 90, sm: 120, md: 140 },
              objectFit: "contain",
              filter: "drop-shadow(0 0 18px rgba(124,58,237,0.5))",
              mb: 2,
            }}
          />

          <Typography
            variant="h2"
            sx={{
              fontWeight: 900,
              lineHeight: 1.05,
              letterSpacing: "-0.02em",
              textShadow: "0 8px 24px rgba(0,0,0,0.45)",
            }}
          >
            Vaš centar za informacije i novosti
          </Typography>
          <Typography
            variant="h6"
            sx={{
              mt: 1.5,
              maxWidth: 760,
              color: "rgba(255,255,255,0.85)",
            }}
          >
            Ovde objavljujemo priče i uvide iz prakse zakazivanja. Mladi smo
            sistem i tek gradimo veća partnerstva — zato delimo činjenice koje
            pomažu biznisima da danas bolje organizuju termine.
          </Typography>

          <Stack direction="row" spacing={1.5} sx={{ mt: 2 }}>
            <Chip
              icon={<CalendarMonthIcon />}
              label="Pametno zakazivanje"
              variant="outlined"
              sx={{
                borderColor: "rgba(255,255,255,0.35)",
                color: "white",
              }}
            />
            <Chip
              icon={<ArticleIcon />}
              label="Dokazani uvidi"
              variant="outlined"
              sx={{
                borderColor: "rgba(255,255,255,0.35)",
                color: "white",
              }}
            />
          </Stack>
        </Box>
      </Grid>

      <Grid
        item
        xs={12}
        sx={{
          position: "relative",
          zIndex: 1,
          background:
            "linear-gradient(180deg, rgba(255,255,255,0.04) 0%, rgba(255,255,255,0.02) 100%)",
          py: { xs: 4, sm: 6 },
        }}
      >
        <Box sx={{ maxWidth: 1200, mx: "auto", px: { xs: 2.5, sm: 5 } }}>
          <Typography
            variant="h4"
            sx={{
              fontWeight: 800,
              mb: 3,
              color: theme.palette.mode === "dark" ? "white" : "white",
              textShadow: "0 4px 18px rgba(0,0,0,0.35)",
            }}
          >
            Najnovije objave
          </Typography>

          <Grid container spacing={3}>
            {posts.map((post) => (
              <Grid key={post.id} item xs={12} md={6} lg={4}>
                <Paper
                  role="button"
                  tabIndex={0}
                  onClick={() => setActivePost(post)}
                  onKeyDown={(event) => {
                    if (event.key === "Enter" || event.key === " ") {
                      event.preventDefault();
                      setActivePost(post);
                    }
                  }}
                  elevation={0}
                  sx={{
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    borderRadius: 3,
                    overflow: "hidden",
                    background:
                      "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%)",
                    border: "1px solid rgba(255,255,255,0.1)",
                    backdropFilter: "blur(8px)",
                    color: "white",
                    boxShadow: "0 16px 40px rgba(0,0,0,0.25)",
                    transition: "transform 0.25s ease, box-shadow 0.25s ease",
                    cursor: "pointer",
                    "&:hover": {
                      transform: "translateY(-4px)",
                      boxShadow: "0 24px 54px rgba(0,0,0,0.35)",
                    },
                  }}
                >
                  <Box
                    component="img"
                    src={post.image}
                    alt={post.title}
                    loading="lazy"
                    sx={{
                      width: "100%",
                      height: 200,
                      objectFit: "cover",
                    }}
                  />
                  <Box sx={{ p: 2.5, flexGrow: 1 }}>
                    <Stack
                      direction="row"
                      spacing={1}
                      alignItems="center"
                      sx={{ mb: 1 }}
                    >
                      <Chip
                        size="small"
                        label={post.badge}
                        sx={{
                          bgcolor: "rgba(59,130,246,0.18)",
                          color: "#93C5FD",
                          border: "1px solid rgba(59,130,246,0.35)",
                        }}
                      />
                    </Stack>

                    <Typography
                      variant="h6"
                      sx={{ fontWeight: 800, mb: 1, lineHeight: 1.15 }}
                    >
                      {post.title}
                    </Typography>

                    <Typography
                      variant="body2"
                      sx={{ color: "rgba(255,255,255,0.85)", mb: 1.5 }}
                    >
                      {post.excerpt}
                    </Typography>

                    <Stack
                      direction="row"
                      spacing={1.5}
                      alignItems="center"
                      sx={{ mt: "auto" }}
                    >
                      <Avatar
                        sx={{
                          width: 28,
                          height: 28,
                          bgcolor: "rgba(255,255,255,0.15)",
                          border: "1px solid rgba(255,255,255,0.25)",
                        }}
                      >
                        <PersonOutlineIcon fontSize="small" />
                      </Avatar>
                      <Typography variant="caption" sx={{ opacity: 0.9 }}>
                        {post.author}
                      </Typography>
                      <Divider
                        orientation="vertical"
                        flexItem
                        sx={{ borderColor: "rgba(255,255,255,0.18)" }}
                      />
                      <Typography
                        variant="caption"
                        sx={{ opacity: 0.8, display: "flex", gap: 0.5 }}
                      >
                        <CalendarMonthIcon fontSize="inherit" /> {post.date}
                      </Typography>
                    </Stack>
                  </Box>

                  <Box
                    sx={{
                      px: 2.5,
                      pb: 2.5,
                      pt: 0,
                      display: "flex",
                      justifyContent: "flex-end",
                    }}
                  >
                    <Button
                      variant="text"
                      onClick={(event) => {
                        event.stopPropagation();
                        setActivePost(post);
                      }}
                      sx={{
                        fontWeight: 700,
                        color: "#93C5FD",
                        textTransform: "none",
                        "&:hover": { color: "#BFDBFE" },
                      }}
                    >
                      Pročitaj više →
                    </Button>
                  </Box>
                </Paper>
              </Grid>
            ))}
          </Grid>

          <Dialog
            open={Boolean(activePost)}
            onClose={() => setActivePost(null)}
            maxWidth="md"
            fullWidth
          >
            {activePost && (
              <>
                <DialogTitle sx={{ pb: 1 }}>
                  <Stack
                    direction={{ xs: "column", sm: "row" }}
                    spacing={1.5}
                    alignItems={{ xs: "flex-start", sm: "center" }}
                    justifyContent="space-between"
                  >
                    <Typography variant="h6" sx={{ fontWeight: 800 }}>
                      {activePost.title}
                    </Typography>
                    <Box
                      component="img"
                      src={Logo}
                      alt="Zakazuj"
                      sx={{
                        height: { xs: 52, sm: 64 },
                        objectFit: "contain",
                        opacity: 0.9,
                      }}
                    />
                  </Stack>
                </DialogTitle>
                <DialogContent dividers>
                  <Stack spacing={2}>
                    <Box
                      component="img"
                      src={activePost.image}
                      alt={activePost.title}
                      sx={{
                        width: "100%",
                        maxHeight: { xs: 260, sm: 360 },
                        objectFit: "contain",
                        borderRadius: 2,
                      }}
                    />
                    <Stack direction="row" spacing={1} alignItems="center">
                      <Chip size="small" label={activePost.badge} />
                      <Typography variant="caption" color="text.secondary">
                        {activePost.author}
                      </Typography>
                      <Divider orientation="vertical" flexItem />
                      <Typography variant="caption" color="text.secondary">
                        {activePost.date}
                      </Typography>
                    </Stack>
                    {activePost.content.map((paragraph) => (
                      <Typography key={paragraph} variant="body1">
                        {paragraph}
                      </Typography>
                    ))}
                    <Box>
                      <Typography variant="subtitle2" sx={{ mb: 1 }}>
                        Ključne činjenice
                      </Typography>
                      <Stack spacing={1}>
                        {activePost.facts.map((fact) => (
                          <Stack
                            key={fact}
                            direction="row"
                            spacing={1}
                            alignItems="center"
                          >
                            <Chip size="small" label="Fact" />
                            <Typography variant="body2">{fact}</Typography>
                          </Stack>
                        ))}
                      </Stack>
                    </Box>
                    <Box>
                      <Typography variant="subtitle2" sx={{ mb: 0.5 }}>
                        Izvori
                      </Typography>
                      <Stack spacing={0.5}>
                        {activePost.sources.map((source) => (
                          <Typography key={source} variant="caption">
                            {source}
                          </Typography>
                        ))}
                      </Stack>
                    </Box>
                  </Stack>
                </DialogContent>
                <DialogActions>
                  <Button onClick={() => setActivePost(null)}>Zatvori</Button>
                </DialogActions>
              </>
            )}
          </Dialog>

          <Paper
            elevation={0}
            sx={{
              mt: 5,
              p: { xs: 2.5, sm: 3 },
              borderRadius: 3,
              background:
                "linear-gradient(180deg, rgba(255,255,255,0.06) 0%, rgba(255,255,255,0.03) 100%)",
              border: "1px solid rgba(255,255,255,0.1)",
              backdropFilter: "blur(8px)",
              color: "white",
            }}
          >
            <Grid container spacing={3} alignItems="center">
              <Grid item xs={12} md={7}>
                <Typography variant="h5" sx={{ fontWeight: 800 }}>
                  Preuzmite Zakazuj mobilnu aplikaciju
                </Typography>
                <Typography variant="body2" sx={{ mt: 1, opacity: 0.9 }}>
                  Link za preuzimanje možete otvoriti direktno ili skenirati QR
                  kod koji dobijate od radnje. Aplikacija vas vodi kroz prijavu,
                  registraciju i zakazivanje u par koraka.
                </Typography>
                <Stack
                  direction={{ xs: "column", sm: "row" }}
                  spacing={2}
                  sx={{ mt: 2 }}
                >
                  <Link
                    href="https://apps.apple.com/app/id6754040503"
                    underline="none"
                    sx={{
                      px: 2.5,
                      py: 1,
                      borderRadius: 999,
                      fontWeight: 700,
                      color: "white",
                      border: "1px solid rgba(255,255,255,0.35)",
                      "&:hover": { background: "rgba(255,255,255,0.08)" },
                    }}
                  >
                    App Store
                  </Link>
                  <Link
                    href="https://play.google.com/store/apps/details?id=com.stellar.zakazuj"
                    underline="none"
                    sx={{
                      px: 2.5,
                      py: 1,
                      borderRadius: 999,
                      fontWeight: 700,
                      color: "white",
                      border: "1px solid rgba(255,255,255,0.35)",
                      "&:hover": { background: "rgba(255,255,255,0.08)" },
                    }}
                  >
                    Google Play
                  </Link>
                </Stack>
              </Grid>
              <Grid item xs={12} md={5}>
                <Grid container spacing={2} justifyContent="center">
                  {[
                    { label: "App Store", src: QrAppStore },
                    { label: "Google Play", src: QrGooglePlay },
                  ].map((item) => (
                    <Grid item xs={6} sm={5} key={item.label}>
                      <Stack spacing={1} alignItems="center">
                        <Box
                          component="img"
                          src={item.src}
                          alt={item.label}
                          sx={{
                            width: "100%",
                            maxWidth: 160,
                            borderRadius: 2,
                            border: "1px solid rgba(255,255,255,0.25)",
                            background: "white",
                            p: 1,
                          }}
                        />
                        <Typography variant="caption" sx={{ opacity: 0.85 }}>
                          {item.label}
                        </Typography>
                      </Stack>
                    </Grid>
                  ))}
                </Grid>
              </Grid>
            </Grid>
          </Paper>

          {/* <MobileAppPromo
            googlePlayUrl="https://play.google.com/store/apps/details?id=com.zakazuj"
            appStoreUrl="https://apps.apple.com/app/id1234567890"
            apkUrl="" // ili npr. "/app/Zakazuj-1.0.0.apk"
            qrImage="/app/qr-zakazuj.png"
            phoneShot="/app/screen-1.png"
          /> */}

          <Box
            sx={{
              pt: 4,
              pb: 2,
              textAlign: "center",
              color: "rgba(255,255,255,0.65)",
            }}
          >
            <Typography variant="caption">
              Zakazuj © {new Date().getFullYear()}
            </Typography>
          </Box>
        </Box>
      </Grid>
    </Grid>
  );
}
